import Model from 'src/storage/base';

export class DoctorModel extends Model {
  id = 'doctor';
  defaultState = () => ({
    categories: [],
    patientFlg: true,
    availableSlots: [],
    tab: 'slot',
    answers: []
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  apiConfig = {
    doctor_detail: {
      url: 'doctor/detail',
      validation: {
        username: 'string'
      },
      cancellable: true
    },
    doctor_chat: {
      url: 'doctor/chat',
      validation: {
        id: 'number',
        patientFlg: 'boolean',
        patientNumber: 'string',
        fee: 'number'
      },
      cancellable: true
    },
    getAvailableSlots: {
      url: 'schedule/listAvailable',
      validation: {
        from: 'number',
        to: 'number'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile',
    openDoctor: 'onOpenDoctor'
  };

  handleProfile = (profile) => {
    this.setState({ user: profile });
  };

  onOpenDoctor = (doctor = {}) => {
    this.setState({
      doctor,
      answers: doctor.questions?.map((question) => ({ question, answer: '' }))
    });
  };

  loadDetail = (username, cb) => {
    this.setState({ doctor: {} });
    this.api('doctor_detail', { username }, (error, doctor, success) => {
      if (!error) {
        this.emit('openDoctor', doctor);
      }
      cb && cb(error, doctor, success);
    });
  };

  getAvailableSlots = (id) => {
    this.setState({
      availableSlots: []
    });
    const date = Date.now();
    this.api(
      'getAvailableSlots',
      { id, from: date, limit: 2, skip: 0, to: 0 },
      (err, data) => {
        this.setState({ availableSlots: !err ? data : [] });
      }
    );
  };

  haveAvailableSlots = () => {
    return this.state.availableSlots?.filter((slot) => !slot.patientId).length > 0;
  };

  resetDoctorChat = () => {
    this.setState({
      patientFlg: true,
      patientNumber: '',
      fee: ''
    });
  };

  chatNext = (cb) => {
    this.api(
      'doctor_chat',
      {
        id: this.user?.id,
        patientFlg: this.state.patientFlg,
        patientNumber: this.state.patientNumber,
        fee: 0
      },
      cb
    );
  };

  chatPay = (cb) => {
    this.api(
      'doctor_chat',
      {
        id: this.user?.id,
        patientFlg: this.state.patientFlg,
        patientNumber: '',
        fee: this.state.fee
      },
      cb
    );
  };

  getDoctor = () => {
    return (
      this.state.doctor || {
        treatments: [],
        tags: []
      }
    );
  };
}

const model = new DoctorModel();
export default model;
